import React, { useContext, useState, useEffect } from 'react';

import * as Yup from 'yup';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ICICIDMTMoneyTransfer as DMT_TRANSFER } from 'Components/Api/DMTTransferApi';

import { SELECT_DMT_CHARGE_AND_COMM } from 'Components/utils';

import { DMTTransactionConfirmation } from 'Components/Alert/DMTTransactionConfirmation';
import {
    Select as BENE_SELECT,
    Delete as BENI_DELETE
} from 'Components/Api/BeneficiaryAPI';
import { useHistory } from 'react-router';
import {
    MONEY_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
    MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { BalanceContext } from 'Components/BalanceContext';
import { LOGOUT } from 'ConstComponents';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import PrintConfirmation from 'Pages/InnerPages/Report/PrintConfirmation';
import { SelectDMTForReceiptForWeb as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';
import { DMTTransactionPrint } from 'Components/Print/DMTPrint';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

export default function BeneficiaryList({
    senderID,
    senderName,
    ActiveDMTName,
    senderMobile,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);

    const classes = commonStyle();
    const history = useHistory();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [confirmDeleteAlertRequest, setDeleteConfirmAlertRequest] = useState(
        {}
    );
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [ResponseAlert, setResponseAlert] = useState({});
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);

    const [printConfirmationRequest, setPrintConfirmationRequest] = useState(
        {}
    );
    const [isChargeOpen, setIsChargeOpen] = useState(false);
    const [printData, setPrintData] = useState(null);
    const [isPrint, setIsPrint] = useState(false);

    useEffect(() => {
        createColumns();
        select();
    }, [senderID]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);
        if (senderID === undefined) return;

        if (senderID === '') return;

        var beneReqObj = JSON.stringify({ SenderID: senderID });

        setLoading(false);
        setList([]);
        var response = await BENE_SELECT(beneReqObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No Beneficiary Found');
            return;
        }

        setList(data);
    };

    const displayCharge = (values) => {
        setPrintConfirmationRequest(values);
        updateCustomCharge(true);
    };

    const updateCustomCharge = (flag) => {
        setIsChargeOpen(flag);
    };

    const Print = ({ ID, Charge }) => {
        SelectPrintData(ID, Charge);
    };

    const SelectPrintData = async (TransactionMasterID, Charge) => {
        var req = {
            ID: TransactionMasterID
        };
        var request = JSON.stringify(req);

        const resp = await TRANSACTION_RECEIPT(request);

        if (!resp.isAuthorized) LOGOUT();

        if (!resp.status) return;

        var data = JSON.parse(resp.data);

        data.Charge =
            Charge === undefined || Charge === null ? data.Charge : Charge;
        setPrintData(data);

        setIsPrint(true);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Verified',
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });
        columns.push({
            label: 'Name',
            name: 'Name',
            bold: true
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo',
            bold: true
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            editableWithNumberOnly: true,
            length: 6
        });
        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }

        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            buttonTitle: 'Transfer',
            buttonWithTitle: true,
            callback: (value) => {
                TransferConfirmation(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'BeneficiaryID',
            icon: 'DeleteIcon',
            deleteButtonWithTitle: true,
            callback: (value) => {
                Delete(value);
            }
        });
        columns.push({
            label: 'SenderID',
            name: 'SenderID',
            hide: true
        });
        setMainColumns(columns);
    };

    const VerifyConfirmation = async (values) => {
        setConfirmAlertRequest({});
        let SenderID = values[10];
        let RechargePin = values[7];

        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }
        if (RechargePin === undefined) {
            RechargePin = '';
        }

        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[2],
            BankName: values[3],
            AccountNumber: values[4],
            IFSC: values[5],
            Amount: 1,
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_VERIFY_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            IsPin: isPin
        };

        var errorValidation = false;

        await VerifyValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const Verify = async (values) => {
        var jsonObj = {
            BeneficiaryID: values.BeneficiaryID,
            Name: values.BeniName,
            SenderName: senderName,
            BankName: values.BankName,
            AccountNo: values.AccountNumber,
            IFSC: values.IFSC,
            Mobile: senderMobile,
            SenderID: values.SenderID,
            PaymentType: 'IMPS',
            Through: 'WEB',
            IsVerify: true,
            Amount: 1,
            RechargePin: values.RechargePin, 
        };

        setLoading(true);
        setIsError(false);

        var request = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(request);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            select();
            return;
        }

        setSeverity('success');

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);

        setIsError(true);
        if (!response.status) {
            let d = JSON.parse(response.data);
            setResponseMessage(d.Message);
            setSeverity('error');
            setIsError(true);
            select();
            return;
        }

        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        select();
    };

    const VerifyValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    const TransferValidation = Yup.object({
        BeniName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNumber: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(1, PLEASE_PROVIDE_VALID + 'amount'),
        RechargePin: Yup.string().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.string().required('Please enter valid pin')
        })
    });

    const Transfer = async (request) => {
        let jsonObj = {
            Name: request.BeniName,
            SenderName: senderName,
            BankName: request.BankName,
            AccountNo: request.AccountNumber,
            IFSC: request.IFSC,
            BeneficiaryID: request.BeneficiaryID,
            Mobile: senderMobile,
            SenderID: request.SenderID,
            Amount: request.Amount,
            PaymentType: request.PaymentType,
            RechargePin: request.RechargePin,
            Remark: request.Remark, 
        };
        setIsError(false);
        setLoading(true);

        var api_request = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(api_request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            let d = JSON.parse(response.data);
            setResponseMessage(d.Message);
            setSeverity('error');
            setIsError(true);
            select();
            return;
        }

        var data = JSON.parse(response.data);

        setResponseAlert(data);
        setIsResponseAlertOpen(true);

        select();
    };

    const TransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        var requestObj = {
            ActiveDMTName: ActiveDMTName,
            Amount: values[6]
        };

        setLoading(true);
        const { Commission, Charge, Total } = await SELECT_DMT_CHARGE_AND_COMM(
            requestObj
        );
        setLoading(false);

        let SenderID = values[10];
        let RechargePin = values[7];

        if (isPin !== 'true') {
            SenderID = values[9];
            RechargePin = '';
        }
        let jsonObj = {
            BeneficiaryID: values[0],
            BeniName: values[2],
            BankName: values[3],
            AccountNumber: values[4],
            IFSC: values[5],
            Amount: values[6],
            RechargePin: RechargePin,
            SenderID: SenderID,
            OperatorID: MONEY_TRANSFER_OPERATOR_TRANSFER_CODE,
            ServiceID: MONEY_TRANSFER_CODE,
            IsPin: isPin,
            Commission: Commission,
            Charge: Charge,
            Total: Total
        };

        setIsError(false);
        var errorValidation = false;

        await TransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);

            select();
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const Delete = async (values) => {
        setDeleteConfirmAlertRequest({});
        let SenderID = values[10];
        if (isPin !== 'true') {
            SenderID = values[9];
        }
        var request = {
            BeneficiaryID: values[0],
            SenderID: SenderID
        };
        setLoading(true);
        setIsError(false);

        var requestObj = JSON.stringify(request);

        var response = await BENI_DELETE(requestObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            select();
            return;
        }
        setIsDeleteAlertOpen(true);
        setDeleteConfirmAlertRequest(requestObj);
        select();
        setSeverity('success');
        if (formRef.current) formRef.current.handleSubmit();
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);
        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        select();
        var param = {
            Mobile: data.Mobile
        };
        history.push('/IC_SenderSearch', param);
    };

    if (
        senderMobile === undefined ||
        senderMobile === null ||
        senderMobile.length <= 5
    ) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiary List</h2>
            <ReactTable data={list} columns={mainColumns} rowsPerPage={100} />
            {isAlertOpen ? (
                <DMTTransactionConfirmation
                    isOpen={isAlertOpen}
                    ActiveDMTName={ActiveDMTName}
                    title="Domestic Money Transfer"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_TRANSFER_CODE
                        ) {
                            Transfer(request);
                        }
                        if (
                            parseInt(request.ServiceID) ===
                                MONEY_TRANSFER_CODE &&
                            parseInt(request.OperatorID) ===
                                MONEY_TRANSFER_OPERATOR_VERIFY_CODE
                        ) {
                            Verify(request);
                        }
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                        select();
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={() => {
                        sendCallback(ResponseAlert);
                        DashboardBalanceUpdate();
                    }}
                    PrintButtonClick={() => {
                        setIsResponseAlertOpen(false);
                        displayCharge({
                            ID: ResponseAlert.VendorID,
                            Amount: ResponseAlert.Amount
                        });
                        setIsChargeOpen(true);
                    }}
                />
            ) : null}

            {isChargeOpen ? (
                <PrintConfirmation
                    isOpen={isChargeOpen}
                    title="Do you want print ?"
                    message="Are you sure to get this print?"
                    request={printConfirmationRequest}
                    positiveButtonClick={(request) => {
                        setIsChargeOpen(false);
                        Print(request);
                    }}
                    negativeButtonClick={(value) => {
                        setIsChargeOpen(false);
                    }}
                />
            ) : null}

            {isPrint ? (
                <DMTTransactionPrint
                    isOpen={isPrint}
                    title="Transaction Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrint(false);
                        DashboardBalanceUpdate();
                    }}
                    negativeButtonClick={() => {
                        setIsPrint(false);
                    }}
                />
            ) : null}

            {isDeleteAlertOpen ? (
                <ConfirmAlert
                    isOpen={isDeleteAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this Beneficiary."
                    request={confirmDeleteAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsDeleteAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsDeleteAlertOpen(false);
                    }}
                />
            ) : null}
        </>
    );
}
